import React from "react";
import Paragraph from "../p/Paragraph";

const Alert = ({ children, type, classe }) => {
  let color;

  if (type === "info") color = "bg-[#dbeafe] text-[#1d4ed8]";
  else if (type === "success") color = "bg-[#bbf7d0] text-[#4ade80]";
  else if (type === "error") color = "bg-[#f5f5f5] text-[#fc3838]";

  return (
    <div
      className={`${color} ${classe} mb-4 flex rounded-lg  p-3 text-sm`}
      role="alert"
    >
      <svg
        aria-hidden="true"
        className="mr-1 inline h-5 w-5 flex-shrink-0 md:mr-3"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <span className="sr-only">Info</span>
      {children}
    </div>
  );
};

export default Alert;
